module.exports = __webpack_public_path__ + "static/media/no-call.18c3decd.png";